
function checkUrl() {

    if (window.location.search != '') {
        var urlParams = new URLSearchParams(window.location.search),
            itemIndex = urlParams.get('itemIndex'),
            theItem = document.querySelector('.look-book-item[data-lookbook-index="' + itemIndex + '"]');

        if (theItem) {
            setTimeout(function () {
                theItem.click();
            }, 500);
        }
    }
}

checkUrl()